import authStore from '../store/authStore';

const backendHost = process.env.REACT_APP_MAIN_BE_HOST;
const backendPort = process.env.REACT_APP_MAIN_BE_PORT_HTTP;
const apiToken = process.env.REACT_APP_MAIN_BE_API_TOKEN || '';

function getBaseUrl(): string {
  const rawHost = (backendHost || '').trim();
  if (!rawHost) {
    throw new Error('REACT_APP_MAIN_BE_HOST is not configured');
  }

  const rawPort = (backendPort || '').trim();
  const hostWithProtocol = /^https?:\/\//i.test(rawHost) ? rawHost : `http://${rawHost}`;
  const url = new URL(hostWithProtocol);

  const isDefaultPort =
    !rawPort ||
    (url.protocol === 'http:' && rawPort === '80') ||
    (url.protocol === 'https:' && (rawPort === '443' || rawPort === '80'));

  if (!url.port && !isDefaultPort) {
    url.port = rawPort;
  }

  const normalizedPath = url.pathname.replace(/\/+$/, '');
  const pathWithApi = normalizedPath.endsWith('/api') ? normalizedPath : `${normalizedPath}/api`;
  url.pathname = pathWithApi.replace(/\/+/g, '/');

  return `${url.origin}${url.pathname}`;
}

/**
 * 
 * @param path 
 * @returns 
 * usage examples: <path> 
 * await apiGet('/users');
 * await apiGet('/users/1');
 */
export async function apiGet<T>(path: string): Promise<T> {
  const baseUrl = getBaseUrl();
  try {
    const res = await fetch(`${baseUrl}${path}`, {
      headers: {
        Authorization: `Bearer ${authStore.token}`,
        'Content-Type': 'application/json',
      },
    });
    if (!res.ok) {
      const text = await res.text();
      if (res.status === 401 && text.includes('Access denied')) {
        authStore.logout();
      }
      throw new Error(text);
    }
    return await res.json();
  } catch (err) {
    console.error('API GET error:', err);
    throw err;
  }
}

/**
 * 
 * @param path 
 * @returns 
 * usage examples: <path> <method> <API token?>
 * await apiRequest('/users/update/1', 'PUT', { name: 'New Name' });
 * await apiRequest('/users/delete/1', 'DELETE');
 */
export async function apiRequest<T>(path: string, method: string, body?: any, token?: string): Promise<T> {
  const baseUrl = getBaseUrl();
  try {
    console.log(`baseUrl: ${baseUrl}, path: ${path}`);
    const res = await fetch(`${baseUrl}${path}`, {
      method,
      headers: {
        Authorization: `Bearer ${token ?? authStore.token ?? apiToken}`,
        'Content-Type': 'application/json',
      },
      body: body ? JSON.stringify(body) : undefined,
    });
    if (!res.ok) {
      const text = await res.text();
      if (res.status === 401 && text.includes('Access denied')) {
        authStore.logout();
      }
      throw new Error(text);
    }
    return await res.json();
  } catch (err) {
    console.error(`API ${method} error:`, err);
    throw err;
  }
}

export async function apiUpload<T>(
  path: string,
  method: string,
  formData: FormData,
  token?: string
): Promise<T> {
  const baseUrl = getBaseUrl();
  try {
    const res = await fetch(`${baseUrl}${path}`, {
      method,
      headers: {
        Authorization: `Bearer ${token ?? authStore.token ?? apiToken}`,
        // Let browser set Content-Type with boundary
      },
      body: formData,
    });
    if (!res.ok) {
      const text = await res.text();
      if (res.status === 401 && text.includes('Access denied')) {
        authStore.logout();
      }
      throw new Error(text);
    }
    return await res.json();
  } catch (err) {
    console.error(`API ${method} upload error:`, err);
    throw err;
  }
}